export enum RVParams {
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  REPORT_FREQUENCY = 'reportFrequency',
  BUSINESS_NAME = 'businessName',
  SERVICE_NAME = 'serviceName',
  CONNECTION_UUID = 'connectionUuid',
  REPORT_TYPE = 'reportType',
}
